import { anatomy as anatomy$1 } from '@zag-js/radio-group';

const anatomy = anatomy$1.rename("segment-group");

export { anatomy };
